// extracted by mini-css-extract-plugin
export const sectionStepSlider = "stepSlider-module--sectionStepSlider--1YBjP";
export const sectionContent = "stepSlider-module--sectionContent--1V5G8";
export const sectionContainer = "stepSlider-module--sectionContainer--2ATmD";
export const sectionHeading = "stepSlider-module--sectionHeading--3JIud";
export const sliderWrap = "stepSlider-module--sliderWrap--1wooa";
export const stepSlideItem = "stepSlider-module--stepSlideItem--3HdAB";
export const slideItemWrap = "stepSlider-module--slideItemWrap--lTBXe";
export const downloadLinks = "stepSlider-module--downloadLinks--1-raR";
export const domainTab = "stepSlider-module--domainTab--16jSm";
export const realEstateTab = "stepSlider-module--realEstateTab--1riFr";
export const siImageWrap = "stepSlider-module--siImageWrap--9s9rV";
export const siContentWrap = "stepSlider-module--siContentWrap--240Ra";
export const mobileSlides = "stepSlider-module--mobileSlides--1RuiX";
export const mobileSlideItem = "stepSlider-module--mobileSlideItem--2qVu6";
export const msiImageWrap = "stepSlider-module--msiImageWrap--1fHB9";
export const msiContentWrap = "stepSlider-module--msiContentWrap--eYzKz";